<!-- <vs-success-msg *ngIf="showSuccess"></vs-success-msg> -->
<div class="row my-profile custom-zero-margin">
  <div class="col-md-12 tabcontent-display-line">
    <div class="row custom-bottom-border">
      <div class="col-md-12">
        <h5 class="tabcontent-display-line-section-heading">
          {{ "myProfile.NotificationEmail" | cxTranslate }}
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="secondary-header">
          {{ "myProfile.addEmailHeader" | cxTranslate }}
        </h6>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="myprofilenotify">
          <div class="row">
            <div class="col-md-12 custom-margin">
              <div class="vs-text-field"  *ngIf="userTypes">
                <label
                  ><span class="require">*</span>{{ "myProfile.orderAcknLabel" | cxTranslate }}</label
                >
                <input
                  class="custom-input"
                  type="text"
                  formControlName="orderacknowledgement"
                  [(ngModel)]="userTypes.orderConfirmationEmail"
                  [ngClass]="
                  (orderacknowledgement.invalid &&  isSubmitted)
                    ? 'error'
                    : ''
                "
                />
                <div *ngIf="isSubmitted && !orderacknowledgement.valid"
                  ><label class="notification-email-error-msg" *ngIf="orderacknowledgement.errors?.required">
                    {{ "myProfile.validMail" | cxTranslate }}
                  </label>
                  <label class="notification-email-error-msg" *ngIf="orderacknowledgement.errors?.pattern">
                    {{ "myProfile.validMail2" | cxTranslate }}
                  </label>
                  </div>
              </div>
            </div>
          </div>
<!--      Business requirement to remove invoiceEmail and shipNotificationEmail 
          <div class="row">
            <div class="col-md-12 custom-margin">
              <div class="vs-text-field"  *ngIf="userTypes">
                <label><span class="require">*</span>{{ "myProfile.shipNotiLabel" | cxTranslate }}</label>
                <input
                  class="custom-input"
                  type="text"
                  formControlName="shipnotify"
                  [(ngModel)]="userTypes.orderShipmentEmail"
                  [ngClass]="
                  (shipnotify.invalid &&  isSubmitted)
                    ? 'error'
                    : ''
                "
                />

                <div *ngIf="isSubmitted && !shipnotify.valid"
                  ><label class="notification-email-error-msg" *ngIf="shipnotify.errors.required">
                    {{ "myProfile.validMail" | cxTranslate }}
                  </label>
                  <label class="notification-email-error-msg" *ngIf="shipnotify.errors.pattern">
                    {{ "myProfile.validMail2" | cxTranslate }}
                  </label>
                  </div>
              </div>
            </div>
          </div> -->
<!--           <div class="row custom-last-child-margin-invoice">
            <div class="col-md-12 custom-margin">
              <div class="vs-text-field"  *ngIf="userTypes">
                <label><span class="require">*</span>{{ "myProfile.invoiceEmailLabel" | cxTranslate }}</label>
                <input
                  class="custom-input"
                  type="text"
                  formControlName="invoicemail"
                  [(ngModel)]="userTypes.invoiceEmail"
                  [ngClass]="
                  (invoicemail.invalid &&  isSubmitted)
                  ? 'error'
                  : ''
              "
                />
                <div *ngIf="isSubmitted && !invoicemail.valid"
                  ><label class="notification-email-error-msg" *ngIf="invoicemail.errors.required">
                    {{ "myProfile.validMail" | cxTranslate }}
                  </label>
                  <label class="notification-email-error-msg" *ngIf="invoicemail.errors.pattern">
                    {{ "myProfile.validMail2" | cxTranslate }}
                  </label>
                  </div>
              </div>
            </div>
          </div> -->
          <div class="row custom-border-top">
            <div class="col-md-3">
              <button
                type="submit" (click)="clearEmail()"
                class="vs-tertiary-btn custom-profile-tertiary-btn">
                {{ "myProfile.cancelBtn" | cxTranslate }}
              </button>
            </div>
            <div class="col-md-3">
              <button
                type="submit"
                (click)="openSuccessMsg(); postEmail(); "
                class="vs-primary-btn custom-profile-primary-btn"
              >
              {{ "myProfile.saveBtn" | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
